<mat-expansion-panel [expanded]="expanded" class="search-extension-panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ title }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container *ngTemplateOutlet="sortingContent"></ng-container>
</mat-expansion-panel>
